import {useEffect} from 'react';
import {useCookies, Cookies} from "react-cookie"

export function Connexion ({handleSubmit, fields, setFields, msg}) {

  document.title = 'Connexion'
  
  const [cookies, setCookie] = useCookies(['accept_cookie'])
  const cook = new Cookies();
  const expirationDate = new Date();
  expirationDate.setFullYear(expirationDate.getFullYear() + 1);
	let accept_cookie = cook.get("accept_cookie") || 'false'

  const handleChange = (e) => {
  	const name = e.target.attributes.name.nodeValue
    setFields({...fields, [name]:e.target.value})
  }

  const handleClick = (e) => {
  	if(e.target.name === 'accept') {
  		setCookie(['accept_cookie'], 'true', { path: '/', expires: expirationDate })
  	} 
  	if(e.target.name === 'refuse') {
  		setCookie(['accept_cookie'], 'refused', { path: '/', expires: expirationDate })
  	} 
  }

  useEffect(()=>{
      document.querySelector('input[name=identifiant]')?.focus()
    }
  , [])

  return (
    <div className="login">
    	<div className="cadre cadre_titre">Connexion à l'espace membres</div>

    	{(accept_cookie === 'false') && 
    	    	<div className="cookie_alert center">
    		    	Ce site utilise des cookies pour la connexion au compte.<br/>
    					Pour vous connecter, vous devez en acceptez l'utilisation.<br/>
    					Ces cookies seront utilisés uniquement pour votre <b>navigation</b>.<br/>
    					(accès à votre espace personnel et sauvegarder vos notes)
    					<br/>
    					<input type='button' name='accept' onClick={handleClick} value='Accepter' /> ou <input type='button' name='refuse' onClick={handleClick} value='Refuser'/><br/><br/>
    	
    					Consulter nos mentions légales pour plus de renseignements.<br/><br/>
    					<a href="https://maths-au-quotidien.fr/legal.php#cookies">Mentions légales</a>
    	    	</div>}

    	{(accept_cookie === 'refused') && 
    	    	<div className="cookie_alert center">
    		    	Vous avez refusé le dépot de cookie permettant la connexion à votre espace membre.<br/>
							Pour pouvoir vous authentifier à nouveau, veuillez d'abord accepter les cookies.
    					<br/>
    					<input name='accept' onClick={handleClick} value='Accepter'/> 
       	    </div>}


    	{(accept_cookie === true) && <div className="cadre">
    			    <input type="text" name="identifiant" placeholder="prenom.nom" onChange={handleChange} />
    			    <br/>
    			    <input type="password" name="mdp" placeholder="Mot de passe" onChange={handleChange} autoComplete="false" />
    			    <br/>
    			    <input style={{width:'60%', padding:'5px 0', marginTop:'15px'}} type="button" name="" value="Connexion" onClick={handleSubmit} />
    			    <br/>
    			    {msg ? <span dangerouslySetInnerHTML={{ __html:msg}}></span> : ''}
    			    <br/>
    			    Pas encore inscrit ? : <a href="https://maths-au-quotidien.fr/formulaire.php">s'inscrire</a> 
    	    	</div>}


    </div>
  );
}